import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    APPOINTMENT_DETAIL_REPORT_GET_START,
    APPOINTMENT_DETAIL_REPORT_GET_SUCCESS,
    APPOINTMENT_DETAIL_REPORT_GET_ERROR,
    AppointmentsDetailReportAction
} from './AppointmentsDetailReportActionsTypes';
import { AppointmentsDetailReportDto } from './AppointmentsDetailReportDto';
import { convertToAppointmentsDetailReport } from './appointmentsDetailReportConverter';

export const getAppointmentsDetailReport = (
    page?: string | number,
    size?: string | number,
    start?: string,
    end?: string
): ThunkAction<void, null, null, AppointmentsDetailReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getClientInsightsReportStart());

        const { marketplaceId } = store.getState().login.auth;
        let url = `/appointments_detail_report?marketplace_id=${marketplaceId}`;

        if (page) url += `&page=${page}`;
        if (size) url += `&size=${size}`;
        if (start) url += `&start_date=${start}`;
        if (end) url += `&end_date=${end}`;

        try {
            const response: AxiosResponse<AppointmentsDetailReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );
            dispatch(getClientInsightsReportSuccess(response.data));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(error());
                dispatch(showError('Too many bookings to display. Please try a shorter date range.'));
            }
        }
    };
};

const getClientInsightsReportStart = (): AppointmentsDetailReportAction => ({
    type: APPOINTMENT_DETAIL_REPORT_GET_START
});

const getClientInsightsReportSuccess = (items: AppointmentsDetailReportDto): AppointmentsDetailReportAction => {
    const appointmentsReportConverted = convertToAppointmentsDetailReport(items);
    return {
        type: APPOINTMENT_DETAIL_REPORT_GET_SUCCESS,
        payload: {
            items: appointmentsReportConverted.items,
            page: appointmentsReportConverted.page,
            size: appointmentsReportConverted.pageSize,
            totalPages: appointmentsReportConverted.totalPages,
            totalRecords: appointmentsReportConverted.totalRecords
        }
    };
};

const error = (): AppointmentsDetailReportAction => ({ type: APPOINTMENT_DETAIL_REPORT_GET_ERROR });
